module.exports = __webpack_public_path__ + "static/img/cx.58c7ee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cx.png
// module id = s5NT
// module chunks = 0